import { Field, FieldAttributes } from 'formik';
import { TextField } from 'formik-mui';
import React from 'react';

type Props = FieldAttributes<any>;

export const FormikTextField: React.FC<Props> = (props) => (
  <Field component={TextField} type="text" size="small" {...props} />
);
